import { Location } from 'history';

export type Maybe<T> = T | null;

export const HASURA_VALIDATION_ERROR = 'validation-failed';
export const ACCESS_DENINED_ERROR = 'access-denied';

export const HASURA_ROLE_ADMIN = 'admin';
export const HASURA_ROLE_USER = 'user';
export const HASURA_ROLE_ANONYMOUS = 'anonymous';
export const HASURA_ROLES = [
	HASURA_ROLE_ADMIN,
	HASURA_ROLE_USER,
	HASURA_ROLE_ANONYMOUS,
];

export const STATUS_INACTIVE = 'inactive';
export const STATUS_ACTIVE = 'active';
export const STATUS_DISABLED = 'disabled';
export const STATUS_DELETED = 'deleted';

export const STATUSES = [
	STATUS_ACTIVE,
	STATUS_INACTIVE,
	STATUS_DISABLED,
	STATUS_DELETED,
];

export type Status =
	| typeof STATUS_ACTIVE
	| typeof STATUS_INACTIVE
	| typeof STATUS_DISABLED
	| typeof STATUS_DELETED;

export type HasuraRole =
	| typeof HASURA_ROLE_ADMIN
	| typeof HASURA_ROLE_USER
	| typeof HASURA_ROLE_ANONYMOUS;

export type AppLocation = Location<{
	readonly nextPathname: string;
}>;

export enum Roles {
	Patient = 'patient',
	Driver = 'driver',
	Administrator = 'administrator',
	Public = 'public',
}
